import { useFormContext, Controller } from 'react-hook-form';
import {
  SelectProps,
  FormControl,
  FormHelperText,
  Stack,
  Typography,
  IconButton,
} from '@mui/material';
import Label from '../label/Label';
import { Iconic } from '../iconic';

interface RHFMQuantityProps extends Omit<SelectProps, 'label' | 'variant'> {
  name: string;
  label?: string;
  placeholder?: string;
  helperText?: React.ReactNode;
  wrap?: boolean;
  control?: any;
}

export default function RHFQuantity({
  name,
  label,
  helperText,
  sx,
  control,
  wrap,
  ...other
}: RHFMQuantityProps) {
  const { control: controContext } = useFormContext();

  return (
    <Controller
      name={name}
      control={control ?? controContext}
      defaultValue={other.defaultValue ?? 0}
      render={({ field, fieldState: { error } }) => (
        <FormControl sx={sx} disabled={other.disabled}>
          {label && <Label id={name}> {label} </Label>}

          <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
            <IconButton
              onClick={() => field.onChange(field.value <= 0 ? 0 : field.value - 1)}
              disabled={other.disabled}
            >
              <Iconic icon="eva:minus-fill" />
            </IconButton>
            <Typography>{field.value ?? 0}</Typography>
            <IconButton
              onClick={() => field.onChange((field.value ?? 0) + 1)}
              disabled={other.disabled}
            >
              <Iconic icon="eva:plus-fill" />
            </IconButton>
          </Stack>

          {(!!error || helperText) && (
            <FormHelperText error={!!error}>{error ? error?.message : helperText}</FormHelperText>
          )}
        </FormControl>
      )}
    />
  );
}
